"use strict";

import React from 'react';

const ProductGalleryThumbnailSlide = ({thumbnail={},
                                 imgStyle={display: 'block',},
                                 imgAlt='Product Slide Thumbnail',
                                 imgPath='/assets/img/products/large/',
                                 lazyLoad=false,
                                 lazyLoading={}}) => {

    const largeImgSrc = `${!!thumbnail.enlarged_path ? thumbnail.enlarged_path : imgPath}${thumbnail.enlarged_name}`;
    const thumbnailImgSrc = !!largeImgSrc
            ? largeImgSrc
            : `${!!thumbnail.path ? thumbnail.path : '/assets/img/products/medium/'}${thumbnail.name}`;
    const lazyLoadSettings = Object.assign({
        preLoaderElementClassName:'swiper-lazy-preloader',
        imgPlaceholderSrc:''
    }, lazyLoading);

    if(!!thumbnailImgSrc){
        return (
            <React.Fragment>
            {lazyLoad &&
                <React.Fragment>
                    <div className={lazyLoadSettings.preLoaderElementClassName}
                         style={{background: 'transparent',}} />
                    <img data-src={thumbnailImgSrc}
                         src={lazyLoadSettings.imgPlaceholderSrc}
                         className="swiper-lazy"
                         style={imgStyle}
                         alt={imgAlt} />
                </React.Fragment>
            || !!thumbnail.enlarged_name &&
            <img src={thumbnailImgSrc}
                 style={imgStyle}
                 alt={imgAlt} />
            }
            </React.Fragment>
        );
    }
    return null;
};

export default ProductGalleryThumbnailSlide;
